import { scrollToAccommodation } from 'assets/core/js/page/product/results'
import coreSearch from 'assets/core/js/page/product/search'
import { toggleAccommodations } from 'assets/themes/campings/js/page/product/results'
import recap from 'assets/themes/campings/js/page/product/search/recap'
import travelerSelector from 'assets/themes/campings/js/page/product/search/traveler-selector'
import type { Facets } from 'assets/core/js/page/product/search/facets'

const clickViewMoreAccommodationsButton = (partialEl: HTMLElement, _anchor: string): void => {
  const viewMoreAccommodationsButtonEl = partialEl.querySelector<HTMLButtonElement>('button[data-additional-accommodations]')

  if (!viewMoreAccommodationsButtonEl) {
    return
  }

  const target = viewMoreAccommodationsButtonEl.getAttribute('data-additional-accommodations')

  target && toggleAccommodations(target)
}

export default function (facets: Facets): void {
  travelerSelector() // must be init before the search as we need the values of the selector in there
  coreSearch(facets)
  scrollToAccommodation(clickViewMoreAccommodationsButton)
  recap()
}
